/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { variation } from 'ember-launch-darkly';

/**
 *
 * `PageProjectsDashboard` displays a dashboard for a Project.
 *
 *
 * ```
 * <Page::Projects::Dashboard
 *   @organization={{this.model.organization}}
 *   @project={{this.model.project}}
 *   @resources={{this.model.resources}}
 * />
 * ```
 *
 * @class PageProjectsDashboard
 *
 */
/**
 *
 * `organization` is the organization context.
 * @argument organization;
 * @type {Object}
 *
 */
/**
 *
 * `project` is the project context.
 * @argument project;
 * @type {Object}
 *
 */
/**
 *
 * `resources` is a collection of active resources
 * @argument resources;
 * @type {Object}
 *
 */

export default class PageProjectsDashboardComponent extends Component {
  @service abilities;
  @service('resources.project') projects;
  @service userContext;
  @service config;

  get cards() {
    const productCards = [];

    productCards.push({
      component: {
        args: {
          product: null,
        },
        name: 'page/projects/dashboard/resource-card',
      },
      isAvailable: this.abilities.can('list resources'),
      isReleased: true,
    });

    productCards.push({
      component: {
        args: {
          product: null,
        },
        name: 'page/projects/dashboard/billing-summary-card',
      },
      isAvailable: this.abilities.can('view billing-account'),
      isReleased: true,
    });

    productCards.push({
      component: {
        args: {
          product: 'boundary',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('list boundary-clusters'),
      isReleased: this.abilities.can('release boundary-clusters'),
    });

    productCards.push({
      component: {
        args: {
          product: 'consul',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('list consul'),
      isReleased: this.abilities.can('release consul'),
    });

    productCards.push({
      component: {
        args: {
          product: 'packer',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('get packer-registry'),
      isReleased: this.abilities.can('release packer-registry'),
    });

    productCards.push({
      component: {
        args: {},
        name: 'page/projects/dashboard/terraform-card',
      },
      isAvailable: variation('hcp-ui-terraform-dashboard-tile'),
      isReleased: true,
    });

    productCards.push({
      component: {
        args: {
          product: 'vagrant',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('list vagrant-registries'),
      isReleased: this.abilities.can('release vagrant-registries'),
    });

    productCards.push({
      component: {
        args: {
          product: 'vault',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('list vault'),
      isReleased: this.abilities.can('release vault'),
    });

    productCards.push({
      component: {
        args: {
          product: 'radar',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('view vault-radar'),
      isReleased: this.abilities.can('release vault-radar'),
    });

    productCards.push({
      component: {
        args: {
          product: 'secrets',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('list vault-secrets-app'),
      isReleased: this.abilities.can('release vault-secrets-app'),
    });

    productCards.push({
      component: {
        args: {
          product: 'waypoint',
        },
        name: 'page/projects/dashboard/service-card',
      },
      isAvailable: this.abilities.can('read waypoint-application'),
      isReleased: this.abilities.can('release waypoint-application'),
    });

    return productCards;
  }
}
